import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress
} from '@mui/material';
import axios from 'axios';

const AssemblyLifecycleSection = ({ assemblyId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!assemblyId) return;
    setLoading(true);
    setError(null);
    axios
      .get(`/api/assemblies/${assemblyId}/lifecycle`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'Failed to load lifecycle');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [assemblyId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" variant="body2" sx={{ p: 2 }}>
        {error}
      </Typography>
    );
  }

  if (!data) return null;

  const { fittings = [] } = data;

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
        Installation History (Fittings)
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Aircraft</TableCell>
              <TableCell>Assembly Type</TableCell>
              <TableCell>Serial Number</TableCell>
              <TableCell>Position</TableCell>
              <TableCell>Installed</TableCell>
              <TableCell>Removed</TableCell>
              <TableCell>Remarks</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fittings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7}>No installation history</TableCell>
              </TableRow>
            ) : (
              fittings.map((f, idx) => (
                <TableRow key={idx}>
                  <TableCell>{f.aircraftRegistration || '-'}</TableCell>
                  <TableCell>{f.assemblyTypeName || '-'}</TableCell>
                  <TableCell>{f.serialNumber || '-'}</TableCell>
                  <TableCell>{f.position || '-'}</TableCell>
                  <TableCell>{f.installedAt ? new Date(f.installedAt).toLocaleDateString() : '-'}</TableCell>
                  <TableCell>{f.removedAt ? new Date(f.removedAt).toLocaleDateString() : 'Current'}</TableCell>
                  <TableCell>{f.remarks || '-'}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AssemblyLifecycleSection;
